export default __webpack_public_path__ + "img/c88f4206d5c73a6d533d949d2d6bbb90.png";